if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const productSection = document.getElementById(this.dataset.id);
        const variantPicker = productSection.querySelector('.variant_picker');

        this.productButton = productSection.querySelector('[data-add-to-cart]');
        this.stickyButton = this.querySelector('button[data-sticky-atc-button]');
        this.variantTitle = this.querySelector('[data-variant-title]');
        this.toAddonLink = this.querySelector('[data-sticky-atc-addon]');
        this.productImage = this.querySelector('[data-sticky-atc-image] img');

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.boundingClientRect.bottom < 0 && !entry.isIntersecting) {
              this.show();
            } else {
              this.hide();
            }
          });
        });

        observer.observe(this.productButton);

        if (this.stickyButton && this.productButton) {
          this.stickyButton.addEventListener('click', () => {
            this.productButton.click();
          });
        }

        document.addEventListener('variant:change', (event) =>  {
          const { variant } = event.detail;
          this.setAvailable(variant);
          this.setVariantTitle(variant);
          this.setVariantImage(variant);
        });

        document.addEventListener('rebuy.ready', () => {
          const addonWidget = document.querySelector('.widget-type-product-addon:not(.is-hidden)');

          if (addonWidget){
            this.activateAddonLink();
          }
        });

        if (variantPicker) {
          this.activateAddonLink();
        }
      }

      activateAddonLink() {
        if (!this.toAddonLink) return;
        const link = this.toAddonLink.querySelector('a');

        link.href = `#${this.dataset.id}`;
        this.toAddonLink.hidden = false;
      }

      show() {
        this.hidden = false;
      }

      hide() {
        this.hidden = true;
      }

      setAvailable({ available }) {
        this.stickyButton.disabled = !available;
        this.stickyButton.textContent = available
          ? this.getButtonText()
          : window.theme.strings.soldOut;
      }

      setVariantTitle({ title }) {
        if (this.variantTitle) {
          this.variantTitle.textContent = title;
        }
      }

      setVariantImage({ featured_media }) {
        if (featured_media && featured_media.preview_image.src) {
          this.productImage.src = featured_media.preview_image.src + `?width=${this.productImage.width || 100}`;

          if (this.productImage.srcset) {
            this.productImage.removeAttribute('srcset');
          }
        }
      }

      getButtonText() {
        if (this.productButton) {
          const textElement = this.productButton.querySelector('[data-add-to-cart-text]');
          if (textElement) return textElement.textContent;
        }
        return this.stickyButton.dataset.defaultText;
      }
    }
  )
}
